import React from 'react'
import { mount, render } from 'enzyme'

import { DefaultInput } from '../../elements'
import { Guarantor } from '../data/mockStore'
import { GeneralFunctions } from '../../helper'

describe("Elements: DefaultInput",() => {

  it("escapes HTML in error message", () => {
    const props = {
      error: true,
      errorMessage: "<a href='#'>Login</a>"
    }
    const input = render(<DefaultInput {...props}/>)
    expect(input.find("a").length).toBe(0)
  })

  it("allows HTML in error message", () => {
    const props = {
      error: true,
      errorMessage: "<a href='#'>Login</a>",
      allowHTMLInErrorMessage: true
    }
    const input = render(<DefaultInput {...props}/>)
    expect(input.find("a").length).toBe(1)
  })

  it ("allows same id and dataAttribute", () => {
    const props = {
      id: `first_name_${Guarantor.rid}`,
      dataAttribute: "first_name"
    }
    const input = mount(<DefaultInput {...props}/>)
    expect(input.props().id).toBe("first_name_1")
    expect(input.props().dataAttribute).toBe("first_name")
  })

  describe('functions',() => {
    let props, wrapper, result, prevent

    beforeEach(() => {
      props = {
        value : 'hello',
        onKeyPress: val => {
          result = val
        }
      }
      wrapper = mount(<DefaultInput {...props}/>)
      result = wrapper.instance()
    })

    describe('changeInputText', () => {
      describe('if cleaveCurrency is false', () => {
        beforeEach(() => {
          result.changeInputText('a name', 'any')
        })
        it('should assign the unaltered value to state.value', () => {
          expect(result.state.value).toBe('a name')
        })
      })
      describe('if CleaveCureency is true', () => {
        beforeEach(() => {
          wrapper.setProps({ ...props, cleaveCurrency: true })
          result.changeInputText('$120,000', 'any')
        })
        it('should replace non nums characters with an empty string', () => {
          expect(result.state.value).toBe('120000')
        })
      })
      describe('if id is equal to email', () => {
        it('should call trimString from GeneralFunctions', () => {
          spyOn(GeneralFunctions, 'trimString')
          result.changeInputText('  faker@test.com  ', 'email')

          expect(GeneralFunctions.trimString).toHaveBeenCalledTimes(1)
        })
        it('should trim the input', () => {
          result.changeInputText('  faker@test.com  ', 'email')

          expect(result.state.value).toBe('faker@test.com')
        })
      })
    })

    describe('#onKeyPress' , () => {
      it('should run funct', () => {
        const e = {
          which: 1
        }
        wrapper.instance().onKeyPress(e)
        expect(result.which).toBe(1)
      })

      it('should run funct', () => {
        const e = {
          which: 13,
          preventDefault: () => {
            prevent = 'preventDefault'
          },
          target: {
            blur: () => {
              return true
            }
          }
        }
        wrapper.instance().onKeyPress(e)
        expect(prevent).toBe('preventDefault')
      })
    })
  })
})
